import { ListRange, SearchCriteriaBase } from '../../../../common/models';
import { Dimension } from '../../../models/monitoring-dimension';
import { ListQueryParam } from '../../../../common/constants';
import { LatestNotification } from '../../monitoring/models';
import { DeliveryDeviation } from '../../../models';

export interface HandlingUnitOverview {
  huId: string;
  carrierName: string;
  carrierId: string;
  deliveryDeviation: DeliveryDeviation;
  packagingType: string;
  packagingTypeDescription: string;
  barcodeId: number;
  latestNotification: LatestNotification;

  width: Dimension;
  height: Dimension;
  length: Dimension;

  weight: Dimension;
  volume: Dimension;

  internalDeliveryNumber: string;
  externalDeliveryNumber: string;
  routeId: string;
  sapTransportNumber: string;
  forwarderTrackingNumber: string;
  equipmentId: string;
  hasDangerousGoods: boolean;
  plannedGoodsIssueDate: number;
  actualGoodsIssueDate: number;
  plannedDeliveryDate: number;
  estimatedDeliveryDate: number;
}

export interface HandlingUnitMaterial {
  boschMaterialNumber: string;
  boschOrderNumber: string;
  customerMaterialNumber: string;
  customerOrderNumber: string;
  description: string;
  quantity: number;
  unNumber: string;
}

export class HandlingUnitMaterialSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.BoschMaterialNumbers]: string[] = [];
  [ListQueryParam.CustomerMaterialNumbers]: string[] = [];
  [ListQueryParam.BoschOrderNumbers]: string[] = [];
  [ListQueryParam.CustomerOrderNumbers]: string[] = [];

  constructor(params?: Partial<HandlingUnitMaterialSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
